(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('pointerover', function (event) {
  var menu = event.target.closest('.category-menu');
  if (menu) menu.open = true;
});
document.addEventListener('pointerout', function (event) {
  var menu = event.target.closest('.category-menu');
  if (menu && !menu.contains(event.relatedTarget)) menu.open = false;
});
document.addEventListener('focusin', function (event) {
  var menu = event.target.closest('.category-menu');
  if (menu) menu.open = true;
});
document.addEventListener('focusout', function (event) {
  var menu = event.target.closest('.category-menu');
  if (menu && !menu.contains(event.relatedTarget)) menu.open = false;
});

  } catch(e) { console.error(e); }
})();
})();
